export default "__VITE_ASSET__DbIMaS0F__"